import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { InstallationFormFilePluginService } from './formfile.service';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ModalComponent } from '../../../modal/modal.component';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { BaseInstallationEditPageComponent } from '../base-installation/edit-view.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'installation-formfile-edit',
    templateUrl: './formfile-edit.component.html',
    standalone: false
})
export class InstallationFormfileEditPageComponent
  extends BaseInstallationEditPageComponent
  implements OnInit, OnDestroy
{
  plugin: any;
  editForm: UntypedFormGroup;
  formFiles: any[];

  @ViewChild('formfileModal', { static: true }) formfileModal: ModalComponent;

  private sub = new Subscription();

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected router: Router,
    location: Location,
    protected cdRef: ChangeDetectorRef,
    protected pluginService: InstallationFormFilePluginService,
    private translate: TranslateService
  ) {
    super(location, pluginService, activatedRoute, router);
  }

  ngOnInit(): void {
    this.sub.add(
      this.initRoute().subscribe(() => {
        this.initData();
      })
    );
  }

  public save(model: any) {
    this.processing = true;
    this.pluginService
      .updateFormfile(this.inspectionId, this.pointId, this.pluginId, { ...model, files: this.plugin.config.Files })
      .subscribe((el) => {
        this.processing = false;
        this.goToBack();
      });
  }

  public onClose(e: any) {
    this.editForm.controls['value'].markAsTouched();
  }

  public openFileSelector() {
    this.openSelector(this.formfileModal, this.formFiles, this.editForm.controls.value.value);
  }

  public selectFileMenu(item: any) {
    const selectedIndex = this.editForm.controls.value.value === item.selectedIndex ? '' : item.selectedIndex;
    this.editForm.controls.value.setValue(selectedIndex);
  }

  download() {
    this.pluginService.download(this.plugin.inspection, this.plugin.pointId, this.plugin.id, {
      ...this.plugin.config,
      Value: this.editForm.controls.value.value
    });
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  private initData() {
    this.service.getPlugin(this.inspectionId, this.pluginId).subscribe((data) => {
      this.plugin = data;
      this.formFiles = this.plugin.config.Files?.map((f) => {
        const key = `plugins.installationformfile.${f.Value}`;
        const label = this.translate.translations[this.translate.currentLang][key];
        return { value: f.Value, label: label };
      });
      this.initForm();
      this.cdRef.detectChanges();
    });
  }

  private initForm() {
    this.editForm = new UntypedFormGroup({
      value: new UntypedFormControl(this.plugin.config?.Value ?? ''),
      instruction: new UntypedFormControl(this.plugin.config?.Instruction ?? '')
    });
  }
}
